
export default {
  vessel: {
    copyright: {
      fontSize: 'sm',
      textColor: 'grey-darkest',
      textAlign: 'center'
    },
    social: {
      fontSize: 'md',
      textColor: 'primary',
      marginY: 'sm',
      lg: {
        marginY: 0
      }
    }
  },
  data() {
    return {
      socialAccounts: [
        {
          name: 'Facebook',
          icon: 'facebook',
          url: 'https://www.facebook.com/paouris.gr'
        },
        {
          name: 'Instagram',
          icon: 'instagram',
          url: 'https://www.instagram.com/paouris'
        },
        {
          name: 'Youtube',
          icon: 'youtube',
          url: 'https://www.youtube.com/c/paourisgr'
        },
        {
          name: 'Pinterest',
          icon: 'pinterest',
          url: 'https://www.pinterest.com/paourisGR'
        },
        {
          name: 'TikTok',
          icon: 'tiktok',
          url: 'https://www.tiktok.com/@paouris.agricultu'
        }
      ]
    }
  },
  computed: {
    copyright() {
      const title = this.$t('footer.copyrightTitle')
      const rights = this.$t('footer.rightsReserved')

      return `${title}. ${rights}`
    }
  }
}
